export function deadlineBadgeHtml(deliveryDate: string): string {
  if (!deliveryDate) return "";
  const delivery = new Date(deliveryDate);
  if (isNaN(delivery.getTime())) return "";
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diffMs = delivery.getTime() - today.getTime();
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays < 0) {
    return `<span class="deadline-badge deadline-overdue">${Math.abs(diffDays)}d overdue</span>`;
  }
  if (diffDays <= 7) {
    return `<span class="deadline-badge deadline-urgent">${diffDays}d left</span>`;
  }
  if (diffDays <= 30) {
    return `<span class="deadline-badge deadline-soon">${diffDays}d left</span>`;
  }
  return "";
}
